import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { apiServices } from '../services/apiServices';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import Loader from './../components/loaders/loader';
import { Accordion, Card, Container, Row, Col, Badge } from 'react-bootstrap';
import CaseDetails from './../components/inbox/CaseDetails';

class Inbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openCases: [],
            resolvedCases: [],
            approvedCases: [],
            declinedCases: [],
            caseData: null,
            questions: [],
            isLoading: false,
            isDataFetched: false,
            activeCaseID: '',
            sUUID: '',
            isCaseFetched: false,
        }
    }
    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.loadInbox();
    }

    loadInbox = async () => {
        let findOpen = document.querySelector(".collapse.show");
        findOpen.classList.remove('show');
        let makeOpen = document.querySelector(".collapse.openCases");
        makeOpen.classList.add('show');

        this.setState({ caseData: null, isCaseFetched: false});
        let oCoummunity = JSON.parse(localStorage.getItem('community')).community,
            sUUID = oCoummunity.uuid,
            oRequest = {
                // uuid: "78cd2a5ff5bdd9dcc109d7291c294132",
                uuid: sUUID,
                activeYN: 'Y',
                deleteYN: 'N',
                // caseSetAttrFlag: true,
                statusList: ["9", "10", "11", "12", "33", "34"],
                caseSetAttrFlag: true
                // types: ["ALERT", "APPOINTMENT"]
            };

        // console.log("oRequest", oRequest)
        this.setState({ isLoading: true });
        await apiServices.loadInbox(oRequest).then(response => {
            // console.log("response from inbox",response);
            let openCases = [];
            let resolvedCases = [];
            let approvedCases = [];
            let declinedCases = [];
            response.caseSetTO_Attributes_analysis.forEach(data => {
                if (data.status === 9) {
                    openCases.push(data);
                } else if (data.status === 10) {
                    approvedCases.push(data);
                } else if (data.status === 11) {
                    declinedCases.push(data);
                } else if (data.status === 12) {
                    resolvedCases.push(data);
                }
            });
            this.setState({ openCases, resolvedCases, approvedCases, declinedCases, isLoading: false, isDataFetched: true, sUUID }, () => this.state.openCases.length > 0 ? this.getCaseData(this.state.openCases[0].id) : this.setState({isCaseFetched: true}))
        })
    }

    getCaseData = async (id) => {
        this.setState({ caseData: null, isCaseFetched: false});
        let oCoummunity = JSON.parse(localStorage.getItem('community')).community,
            sUUID = oCoummunity.uuid,
            oRequest = {
                uuid: sUUID,
                activeYN: 'Y',
                deleteYN: 'N',
                caseID: id,
                // caseSetAttrFlag: true,
                statusList: ["9", "10", "11", "12", "33", "34"],
                // types: ["ALERT", "APPOINTMENT"]
            };

        // console.log("oRequest",oRequest)
        this.setState({ isLoading: true });
        await apiServices.loadInboxItem(oRequest).then(response => {
            // console.log("response from inbox item",response[0].caseExtensions);
            this.setState({ caseData: response[0], isLoading: false, activeCaseID: id, isCaseFetched: true })
        })
    }

    render() {
        const oHeight = 300,
            aHeight = 300,
            rHeight = 300,
            dHeight = 300;
        return (
            <Container fluid className="my-4 inbox">
            	<Loader isLoading={this.state.isLoading}/>
			    <Row className="bg-white animated fadeIn mx-0">
			        <Col sm={3} className="py-3">
				        <Accordion defaultActiveKey="0">
				            <Card className="border-bottom">
				                <Accordion.Toggle as={Card.Header} eventKey="0" className="d-flex justify-content-between" >
				                    Open <Badge className="align-self-center" variant="dark">{this.state.openCases.length}</Badge>
				                </Accordion.Toggle>
				                <Accordion.Collapse eventKey="0" className="openCases">
				                    <Card.Body className="p-0">
				                    	{this.state.openCases.length > 0 ?
				                    		<Scrollbars style={{ width: '100%', height: oHeight }}>
											    {this.state.openCases.map(oCases=>{
													return (
														<div key={oCases.id} className={this.state.activeCaseID === oCases.id ? "active p-2 border-bottom case_item" : "p-2 border-bottom case_item"} onClick={() => this.getCaseData(oCases.id)}>
															<div className="d-flex w-100 justify-content-between pb-1">
																<h6 className="mb-0">{oCases.applicant.name ? oCases.applicant.name : "Anonymous"}</h6>
																<small className="align-self-center">#{oCases.id}</small>
															</div>
															<div className="pb-1">
																<small>{oCases.city ? `${oCases.city},` : ''} {oCases.country ? oCases.country : ''} </small>
															</div>
															<small>{moment(oCases.createdAt).format("MMM Do YYYY, h:mm:ss a")}</small>
														</div>
														)
													})
												}
											</Scrollbars>
											:
											<div className="text-center py-3">
												{!this.state.isDataFetched ? 'Loading Cases...' : 'No Data'}
											</div>
										}
				                    </Card.Body>
				                </Accordion.Collapse>
				            </Card>
				            <Card className="border-bottom">
				                <Accordion.Toggle as={Card.Header} eventKey="1" className="d-flex justify-content-between" >
				                    Approved <Badge className="align-self-center" variant="primary">{this.state.approvedCases.length}</Badge>
				                </Accordion.Toggle>
				                <Accordion.Collapse eventKey="1">
				                    <Card.Body className="p-0">
				                    	{this.state.approvedCases.length > 0 ? 
				                    		<Scrollbars style={{ width: '100%', height: aHeight }}>
											    {this.state.approvedCases.map(aCases=>{
													return (
														<div key={aCases.id} className={this.state.activeCaseID === aCases.id ? "active p-2 border-bottom case_item" : "p-2 border-bottom case_item"} onClick={() => this.getCaseData(aCases.id, "approved")}>
															<div className="d-flex w-100 justify-content-between pb-1">
																<h6 className="mb-0">{aCases.applicant.name ? aCases.applicant.name : "Anonymous"}</h6>
																<small className="align-self-center">#{aCases.id}</small>
															</div>
															<div className="pb-1">
																<small>{aCases.city ? `${aCases.city},` : ''} {aCases.country ? aCases.country : ''} </small>
															</div>
															<small>{moment(aCases.createdAt).format("MMM Do YYYY, h:mm:ss a")}</small>
														</div>
														)
													})
												}
											</Scrollbars>
											:
											<div className="text-center py-3">
												{!this.state.isDataFetched ? 'Loading Cases...' : 'No Data'}
											</div>
										}
				                    </Card.Body>
				                </Accordion.Collapse>
				            </Card>
				            <Card className="border-bottom">
				                <Accordion.Toggle as={Card.Header} eventKey="3" className="d-flex justify-content-between" >
				                    Declined <Badge className="align-self-center" variant="danger">{this.state.declinedCases.length}</Badge>
				                </Accordion.Toggle>
				                <Accordion.Collapse eventKey="3">
				                    <Card.Body className="p-0">
				                    	{this.state.declinedCases.length > 0 ? 
				                    		<Scrollbars style={{ width: '100%', height: dHeight }}>
												{this.state.declinedCases.map(djCases=>{
													return (
														<div key={djCases.id} className={this.state.activeCaseID === djCases.id ? "active p-2 border-bottom case_item" : "p-2 border-bottom case_item"} onClick={() => this.getCaseData(djCases.id,'rejected')}>
															<div className="d-flex w-100 justify-content-between pb-1">
																<h6 className="mb-0">{djCases.applicant.name ? djCases.applicant.name : "Anonymous"}</h6>
																<small className="align-self-center">#{djCases.id}</small>
															</div>
															<div className="pb-1">
																<small>{djCases.city ? `${djCases.city},` : ''} {djCases.country ? djCases.country : ''} </small>
															</div>
															<small>{moment(djCases.createdAt).format("MMM Do YYYY, h:mm:ss a")}</small>
														</div>
														)
													})
												}
											</Scrollbars>
											:
											<div className="text-center py-3">
												{!this.state.isDataFetched ? 'Loading Cases...' : 'No Data'}
											</div>
										}
				                    </Card.Body>
				                </Accordion.Collapse>
				            </Card>
                            <Card className="border-bottom mb-0">
                                <Accordion.Toggle as={Card.Header} eventKey="2" className="d-flex justify-content-between" >
                                    Resolved <Badge className="align-self-center" variant="success">{this.state.resolvedCases.length}</Badge>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="2">
                                    <Card.Body className="p-0">
                                        {this.state.resolvedCases.length > 0 ?
                                            <Scrollbars style={{ width: '100%', height: rHeight }}>
                                                {this.state.resolvedCases.map(rCases=>{
                                                    return (
                                                        <div key={rCases.id} className={this.state.activeCaseID === rCases.id ? "active p-2 border-bottom case_item" : "p-2 border-bottom case_item"} onClick={() => this.getCaseData(rCases.id,'resolved')}>
                                                            <div className="d-flex w-100 justify-content-between pb-1">
                                                                <h6 className="mb-0">{rCases.applicant.name ? rCases.applicant.name : "Anonymous"}</h6>
                                                                <small className="align-self-center">#{rCases.id}</small>
                                                            </div>
                                                            <div className="pb-1">
                                                                <small>{rCases.city ? `${rCases.city},` : ''} {rCases.country ? rCases.country : ''} </small>
                                                            </div>
                                                            <small>{moment(rCases.createdAt).format("MMM Do YYYY, h:mm:ss a")}</small>
                                                        </div>
                                                        )
                                                    })
                                                }
                                            </Scrollbars>
                                            :
                                            <div className="text-center py-3">
                                                {!this.state.isDataFetched ? 'Loading Cases...' : 'No Data'}
                                            </div>
                                        }
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
				        </Accordion>
			        </Col>
			        <Col sm={9} className="border-left py-3 position-relative">
			        	{this.state.caseData ? 
                            <CaseDetails caseData={this.state.caseData} loadInbox={this.loadInbox} sUUID={this.state.sUUID}/> 
                            : 
                            <div className="text-center">{this.state.isCaseFetched ? 'No Data' : 'Loading...'}</div> }
			        </Col>
			    </Row>
			</Container>
        );
    }
}

export default Inbox;